<template>
  <validation-provider
    v-slot="{ errors, reset }"
    class="validate-tooltip grid-x"
    :name="$attrs.placeholder"
    :rules="rules"
    :vid="$attrs.id"
    mode="eager"
  >
    <textbox
      v-model="localValue"
      v-bind="{ ...$props, ...$attrs }"
      v-on="$listeners"
    />
    <transition name="fade">
      <span
        v-if="errors[0]"
        class="cell shrink error popover"
        @click="reset()"
        v-text="errors[0]"
      />
    </transition>
  </validation-provider>
</template>

<script>
export default {
  name: 'TextboxWithValidation',
  inheritAttrs: false,
  props: {
    rules: {
      type: [ String, Array, Object ],
      default: '',
    },
    value: {
      type: [ String, Number ],
      default: '',
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
};
</script>
